import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface StatTileProps {
  label: string;
  value: string;
  hint?: ReactNode;
  icon?: ReactNode;
  /** Direction of the hint, when it carries a good/bad meaning. */
  tone?: 'neutral' | 'good' | 'critical';
  /** The one hero figure of the view – exactly one per dashboard. */
  hero?: boolean;
}

const TONES = {
  neutral: 'text-[var(--ink-3)]',
  good: 'text-[var(--good)]',
  critical: 'text-[var(--critical)]',
} as const;

export function StatTile({ label, value, hint, icon, tone = 'neutral', hero }: StatTileProps) {
  return (
    <div className="card flex flex-col gap-1.5 px-5 py-4">
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs font-medium text-[var(--ink-2)]">{label}</p>
        {icon ? <span className="text-[var(--ink-3)]">{icon}</span> : null}
      </div>
      <p
        className={cn(
          'font-semibold tracking-tight text-[var(--ink)]',
          hero ? 'text-4xl sm:text-5xl' : 'text-2xl',
        )}
      >
        {value}
      </p>
      {hint ? <p className={cn('text-xs', TONES[tone])}>{hint}</p> : null}
    </div>
  );
}
